<template>
  <section>
    <pdf-view />
    <VerReporte />
    <h3 class="blue--text">
      <v-icon color="blue">today</v-icon> Detalle refrigerio
    </h3>
    <v-card class="py-0">
      <v-card-text class="secondary py-0">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <v-layout wrap row>
              <v-flex md6 xs12>
                <strong>DEPENDENCIA: </strong
                >{{ this.persona.movilidad.unidad }}
              </v-flex>
              <v-flex xs12 md6>
                <strong>SERVIDOR PÚBLICO: </strong>{{ persona.nombres }}
                {{ persona.ap_paterno }} {{ persona.ap_materno }}
              </v-flex>
            </v-layout>
            <!--MARCADOS ORIGINALES    @input="bandera_genera == false"-->
            <v-layout wrap justify-space-between>
              <!-- <v-flex md6>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  v-model="form.fecha_desde"
                  @input="listaDetalleRefrigerio(type)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha desde"
                />
              </v-flex>
              <v-flex md6>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  v-model="form.fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha hasta"
                  @input="listaDetalleRefrigerio(type)"
                />
              </v-flex> -->
              <v-flex md6 xs12>
                <v-text-field
                  class="text-field-reducido"
                  type="number"
                  v-model="form.gestion"
                  @change="listaDetalleRefrigerio()"
                  :rules="$validate(['required'])"
                  required
                  label="Gestión"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex md6 xs12>
                <v-autocomplete
                  class="text-field-reducido"
                  :items="meses"
                  item-value="id"
                  item-text="valor"
                  v-model="form.mes"
                  @change="listaDetalleRefrigerio()"
                  :rules="$validate(['required'])"
                  required
                  label="Seleccionar mes"
                  outline
                  clearable
                  success
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between>
              <v-flex shrink>
                <strong>TOTAL DIAS DESCUENTO:</strong>
                {{ total_dias_descuento }}
              </v-flex>
              <v-flex shrink>
                <strong>TOTAL DIAS HABILES:</strong> {{ total_dias_habiles }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text class="primary py-0 px-2">
        <v-data-table
          :headers="headers"
          :items="l_refrigerio_detalle"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          item-key="index"
          rows-per-page-text="Filas por pagina"
          :rows-per-page-items="[10, 20, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                id="cabecera_tabla"
                @click="changeSort(header.value)"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{
                $moment(props.item.fecha)
                  .format("dddd")
                  .toUpperCase()
              }}
            </td>
            <td class="text-xs-center">
              {{ $moment(props.item.fecha).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ props.item.dias_descuento }}</td>
            <td class="text-xs-center">
              <v-layout
                v-if="props.item.loading != true"
                align-center
                justify-space-between
              >
                <table class="table-refrigerio">
                  <tr
                    v-for="detalle in props.item.detalles"
                    :key="detalle.index"
                    :style="
                      detalle.descuenta > 0
                        ? 'background:rgb(219, 62, 177,0.3'
                        : detalle.tipo_marcado == 'I'
                        ? 'background:rgb(252, 76, 2,0.3'
                        : ''
                    "
                  >
                    <td style="width: 100%;">{{ detalle.descripcion }}</td>
                  </tr>
                  <tr v-if="props.item.detalles.length == 0">
                    -
                  </tr>
                </table>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import PdfView from "./components/PdfView.vue";
import VerReporte from "./dialogs/VerReporte";
import VerDetalleDia from "./components/VerDetalleDia.vue";

export default {
  components: { PdfView, VerReporte, VerDetalleDia },
  mixins: [validate],
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      valid: true,
      persona: { movilidad: {} },
      form: {
        mes:parseInt( this.$route.params.mes)-1,//this.$moment().month(),
        gestion:parseInt( this.$route.params.gestion) //this.$moment().year()
      },
      loading: false,
      headers: [
        {
          text: "Día",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Fecha",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Descuento refrigerio",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Detalle",
          sortable: false,
          value: "",
          align: "center"
        }
      ],
      meses: [
        { id: 0, valor: "ENERO" },
        { id: 1, valor: "FEBRERO" },
        { id: 2, valor: "MARZO" },
        { id: 3, valor: "ABRIL" },
        { id: 4, valor: "MAYO" },
        { id: 5, valor: "JUNIO" },
        { id: 6, valor: "JULIO" },
        { id: 7, valor: "AGOSTO" },
        { id: 8, valor: "SEPTIEMBRE" },
        { id: 9, valor: "OCTUBRE" },
        { id: 10, valor: "NOVIEMBRE" },
        { id: 11, valor: "DICIEMBRE" }
      ],
      atrasosMin: 0,
      user: this.$storage.get("user"),
      id_persona: null,
      total_dias_descuento: 0,
      total_dias_habiles: 0,
      l_refrigerio_detalle: []
    };
  },
  async created() {
    // OBTENEMOS EL ID PERSONA
    this.id_persona = this.$route.params.id_persona
      ? this.$route.params.id_persona
      : this.user.id_persona;
    await this.obtenerPersonas(this.id_persona);
    await this.listaDetalleRefrigerio();
  },
  computed: {
    fecha_desde() {
      return this.$moment()
        .month(this.form.mes)
        .year(this.form.gestion)
        .startOf("month")
        .format("YYYY-MM-DD");
    },
    fecha_hasta() {
      return this.$moment()
        .month(this.form.mes)
        .year(this.form.gestion)
        .endOf("month")
        .format("YYYY-MM-DD");
    }
  },
  async mounted() {},
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async obtenerPersonas(id_persona) {
      try {
        this.loading = true;
        let persona_tmp;
        let res = await this.$service.graphql({
          query: `
            query{
              personas(id:${id_persona}){
                rows{
                  id
                  nombres
                  ap_paterno
                  ap_materno
                  nro_doc
                }
              }
            }
          `
        });
        if (res.personas) {
          persona_tmp = res.personas.rows[0];
        }
        // OBTENEMOS MOVILIDAD
        res = await this.$service.graphql({
          query: `
            query{
              vListaPersonals(id_persona:${id_persona}){
                rows{
                  id_estado
                  nro_doc
                  nro_complemento
                  item
                  unidad
                  cargo
                  estado
                  activo_pasivo
                }
              }
            }
          `
        });
        persona_tmp.movilidad = res.vListaPersonals.rows[0];
        this.persona = persona_tmp;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async listaDetalleRefrigerio() {
      this.loading = true;
      try {
        if (this.fecha_desde && this.fecha_hasta) {
          let rpta = await this.$service.graphql({
            query: `
            query{
              getDetalleRefrigerio(id_persona:${this.id_persona},fecha_desde:"${this.fecha_desde}",fecha_hasta:"${this.fecha_hasta}"){
                dias_habiles
                dias_descuento
                rows{
                id_persona
                fecha
                dias_descuento
                detalles{
                  tipo_detalle
                  descuenta
                  descripcion
                }
              }
              }
            }
            `
          });
          var refrigerio = rpta.getDetalleRefrigerio;
          this.l_refrigerio_detalle = refrigerio.rows;
          this.total_dias_descuento = refrigerio.dias_descuento;
          this.total_dias_habiles = refrigerio.dias_habiles;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    }
  }
};
</script>
<style lang="scss">
.color_letras {
  color: azure;
}
.table-refrigerio {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/DetalleRefrigerioFuncionario.vue